import { ENDPIONTS, PaginatedResult } from "@api";
import { PaperHeader } from "@components";
import { useFetch } from "@hooks";
import { Department } from "@models";
import {
  ComplexHeader,
  RowModifier,
  Table,
  TableVerticalConfigs,
} from "@shared";
import { AnnualLeaveReport } from "@viewModels";
import { BranchSelection } from "@widgets";
import { useEffect, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { useNavigate, useSearchParams } from "react-router-dom";

type Search = {
  branchId: number | null;
  departmentId: number | null;
  employeeId: number | null;
};

const AnnualLeavesReport = () => {
  const [queryStrings] = useSearchParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [headers, setHeaders] = useState<ComplexHeader[]>([]);
  const [searchParams, setSearchParams] = useState<Search>({
    branchId: null,
    departmentId: null,
    employeeId: null,
  });

  const fetchData = useFetch<AnnualLeaveReport[]>(
    {
      endPoint: ENDPIONTS.annualLeaveReport,
      queryStrings: queryStrings,
    },
    []
  );

  const fetchDepartments = useFetch<PaginatedResult<Department>>(
    { endPoint: ENDPIONTS.departments, ignorePagination: true },
    new PaginatedResult<Department>()
  );

  useEffect(() => {
    if (fetchData?.data.length > 0) {
      var x: ComplexHeader[] = [];

      Object.keys(fetchData?.data[0]).forEach((d) => {
        if (d !== "actual_Balance")
          x.push({ key: d, title: d.replaceAll("_", " ") });
      });

      setHeaders(x);
    }
  }, [fetchData.isFetching]);

  useEffect(() => {}, [queryStrings]);

  const handleSearch = async () => {
    setIsLoading(true);

    searchParams.branchId &&
      queryStrings.set("branchId", searchParams?.branchId?.toString());
    searchParams.departmentId &&
      queryStrings.set("departmentId", searchParams?.departmentId?.toString());
    searchParams.employeeId &&
      queryStrings.set("employeeId", searchParams?.employeeId?.toString());

    navigate({ search: `?${queryStrings.toString()}` });

    setIsLoading(false);
  };

  const rowModifier: RowModifier = {
    style: (d: AnnualLeaveReport) => {
      if (d.actual_Balance !== d.calculated_Balance) return "table-danger";
      return "";
    },
  };

  return (
    <div className="content container-fluid">
      <div className="row align-items-center">
        <div className="d-flex justify-content-between mb-1">
          <div className="col-4">
            <h3 className="page-title">Annual Leave Summary Report</h3>
          </div>
        </div>
      </div>

      <div className="row mt-3" id="reportcontents">
        <PaperHeader title="Leave Balances Report" />
        <div className="d-flex justify-content-between mb-3">
          <div className="d-flex justify-content-start gap-2 col-6 mt-1">
            <div className="col">
              <div className="form-group mb-0 row">
                <label className="col-form-label col-auto">Branch</label>
                <div className="col">
                  <BranchSelection
                    className="form-control-sm row"
                    isSelectedOption={searchParams?.branchId}
                    returnValue={(val: number) =>
                      setSearchParams((prev) => ({
                        ...prev,
                        branchId: val,
                      }))
                    }
                  />
                </div>
              </div>
            </div>
            <div className="col">
              <div className="form-group mb-0 row">
                <label className="col-form-label col-auto">Department</label>
                <div className="col">
                  <select
                    className="form-control select"
                    style={{ height: "36px" }}
                    name="departmentId"
                    onChange={(e) => {
                      setSearchParams((prev) => ({
                        ...prev,
                        departmentId: +e.target.value,
                      }));
                    }}
                  >
                    <option></option>
                    {fetchDepartments?.data?.items?.map(
                      (d: Department, i: any) => {
                        return (
                          <option
                            selected={
                              searchParams?.departmentId
                                ? +searchParams.departmentId === d.id
                                : false
                            }
                            key={i}
                            value={d.id}
                          >
                            {d.name}
                          </option>
                        );
                      }
                    )}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="col-auto float-end ms-auto">
            <button
              disabled={isLoading}
              className="btn btn-sm btn-outline-info rounded-circle m-1 float-right"
              onClick={handleSearch}
            >
              <RiSearchLine />
            </button>
            {headers.length > 0 && (
              <TableVerticalConfigs
              // exportAsXSLS={onExport}
              // onPrint={{
              //   ref: "reportcontents",
              //   prePrint: onPrint,
              // }}
              />
            )}
          </div>
        </div>
        <div className="row">
          {headers.length > 0 && (
            <Table
              class="table table-striped table-hover mb-0"
              data={fetchData?.data ?? []}
              headers={headers}
              // actions={actions}
              isFetchingPage={fetchData?.isFetching}
              showCounter
              // onPageChange={handlePageChange}
              paginationClass="row mt-3"
              // showTotals
              rowModifier={rowModifier}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AnnualLeavesReport;
